(function() {
  function initProductBoxes() {
    const productLinks = document.querySelectorAll('a[data-product-box]');
    
    productLinks.forEach(link => {
      const productUrl = link.getAttribute('data-product-box');
      // Extract handle from URL like "/products/abc" -> "abc"
      const handle = productUrl.replace('/products/', '').replace(/\/$/, '');
      
      // Create container for the product box
      const container = document.createElement('div');
      container.className = 'product-box-container';
      
      // Replace the link with the container
      link.parentNode.replaceChild(container, link);
      
      // Fetch and render the product
      fetchAndRenderProduct(handle, container);
    });
  }
  
  function fetchAndRenderProduct(handle, container) {
    fetch(`https://www.youkneadsourdough.com.au/products/${handle}.json`)
      .then(response => response.json())
      .then(data => renderProduct(data.product, container))
      .catch(error => {
        console.error('Error fetching product data:', error);
        renderError(container);
      });
  }
  
  function renderProduct(product, container) {
    const price = parseFloat(product.variants[0].price);
    const formattedPrice = new Intl.NumberFormat('en-AU', {
      style: 'currency',
      currency: 'AUD'
    }).format(price);
    
    container.innerHTML = `
      <style>
        .product-box-container .product-box {
          border: 1px solid #ccc;
          border-radius: 10px;
          padding: 10px;
          margin: 10px;
          max-width: 250px;
          text-align: center;
        }
        .product-box-container .product-box__title {
          margin: 0;
          font-family: 'valueserif';
        }
        .product-box-container .product-box__title a {
          text-decoration: none;
          color: rgb(107, 56, 51);
          font-weight: bold;
        }
        .product-box-container .product-box__title a:hover {
          text-decoration: underline;
          color: rgb(233, 123, 54);
        }
        .product-box-container .product-box__image img {
          max-width: 100%;
          height: auto;
        }
        .product-box-container .price__regular {
          font-weight: bold;
          color: rgb(107, 56, 51);
          margin-bottom: 10px;
        }
        .product-box-container .product-box__add-to-cart {
          background-color: rgb(233, 123, 54);
          color: white;
          border: none;
          border-radius: 5px;
          padding: 10px 20px;
          cursor: pointer;
          font-family: 'avenirltpro', serif;
          text-transform: uppercase;
          font-weight: bold;
          display: inline-flex;
          align-items: center;
          justify-content: center;
        }
        .product-box-container .product-box__add-to-cart:hover {
          background-color: rgba(233, 123, 54, 0.8);
        }
        .product-box-container .tick {
          display: none;
          color: white;
          font-size: 10px;
          margin-left: 5px;
        }
      </style>
      <div class="product-box">
        <h4 class="product-box__title">
          <a href="/products/${product.handle}">
            ${product.title}
          </a>
        </h4>
        <a href="/products/${product.handle}" class="product-box__image">
          <img src="${product.images[0].src}" alt="${product.title}" loading="lazy" />
        </a>
        <div class="price__regular">
          <span class="price-item price-item--regular">${formattedPrice}</span>
        </div>
        <button class="product-box__add-to-cart">
          Add to Cart
          <span class="tick">&#10003;</span>
        </button>
      </div>
    `;
    
    // Add click handler for add to cart button
    const addToCartBtn = container.querySelector('.product-box__add-to-cart');
    addToCartBtn.addEventListener('click', () => {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id: product.variants[0].id,
          quantity: 1
        })
      })
      .then(response => response.json())
      .then(data => {
        const tick = container.querySelector('.tick');
        tick.style.display = 'inline';
        setTimeout(() => {
          tick.style.display = 'none';
        }, 2000);
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
      });
    });
  }
  
  function renderError(container) {
    container.innerHTML = '<p>Error loading product data.</p>';
  }
  
  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initProductBoxes);
  } else {
    initProductBoxes();
  }
})();